require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./public-contact-and-perceptions-of-police.json") })
        }
      }, "path---public-contact-and-perceptions-of-police");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---public-contact-and-perceptions-of-police!./.cache/json/public-contact-and-perceptions-of-police.json
// module id = 961
// module chunks = 231608221292675